import { useLocation } from 'react-router';
import { useFlowInfoBySessionId } from '../../../../../flows/src/api/getFlowInfo';
import { useFlowsSession } from '../../../../../flows/src/api/getFlowsSessionById';
import useSessionId from '../../../../../flows/src/hooks/useSessionId';
import useStartFlow from '../../../../../flows/src/hooks/useStartFlow';

interface UseCloseOnline {
  handleCloseOnline: (arg0: string | string[]) => void;
  isLoading: boolean;
}

const useCloseOnline = (): UseCloseOnline => {
  const sessionId = useSessionId();
  const startFlow = useStartFlow();
  const { pathname, search } = useLocation();
  const { data: session, isLoading: isLoadingSession } =
    useFlowsSession(sessionId);
  const { data: flowInfo, isLoading: isLoadingFlow } =
    useFlowInfoBySessionId(sessionId);

  const handleCloseOnline = (id: string | string[]) => {
    if (flowInfo?.next || flowInfo?.id)
      startFlow({
        flowId: flowInfo.next || flowInfo?.id,
        sessionId,
        inputUrl: `${pathname}${search}`,
        partyId: session?.prospect.id,
        quoteId: typeof id === 'string' ? id : undefined,
        quoteIds: typeof id === 'object' ? id : undefined,
      });
  };

  return {
    handleCloseOnline,
    isLoading: isLoadingSession || isLoadingFlow,
  };
};

export default useCloseOnline;
